import { useState } from "react"
import Tooltip from "@/components/shared/Tooltip"

const FacilityId = ({ facilityId }: { facilityId: string }) => {
   const [tooltipContent, setTooltipContent] = useState({
      index: 0,
      content: `Copy: ${facilityId}`,
   })

   const copyToClipboard = () => {
      navigator.clipboard.writeText(facilityId)
      setTooltipContent((prev) => ({ ...prev, content: "Copied!" }))
      setTimeout(
         () =>
            setTooltipContent((prev) => ({
               index: prev.index + 1,
               content: `Copy: ${facilityId}`,
            })),
         1200
      )
   }

   return (
      <Tooltip
         key={tooltipContent.index}
         content={tooltipContent.content}
      >
         <span className="customers-facilities-table__facility-id-wrapper">
            <span
               className="customers-facilities-table__facility-id"
               onClick={copyToClipboard}
            >
               {facilityId}
            </span>
         </span>
      </Tooltip>
   )
}

export default FacilityId
